import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TaskService } from './services/task.service';

export function provideOutlookTaskDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([TaskService]);
}
